import { Radio, RadioGroup, FormControlLabel } from "@mui/material";
import { useCallback, useMemo } from "react";
const UnitsRadioGroup = ({ value, onChange, options }) => {

  const handleChange = useCallback((event, value) => {
    const unit = options?.find((option) => option.value === +value);
    onChange && onChange({
      target: {
        value: unit
      }
    });
  }, [onChange, options]);

  const chosenUnit = useMemo(() => {
    return value?.value;
  }, [value]);

  return (
    <RadioGroup 
      value={chosenUnit}
      onChange={handleChange}
      row
    >
       {options?.map((option) => (
        <FormControlLabel key={option.value} value={option.value} control={<Radio />} label={option.label} />
      ))}
    </RadioGroup>
  )

}

export default UnitsRadioGroup;